import * as Actions from '../actions/actions';
import h from 'virtual-dom/h';
import { sendRequest } from '../../../lib-alme-request/src/lib-alme-request';
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState} from "../../../../wireup/AlmeState";
import {Dictionary, Mutator} from "../../../../types/rendering";
import {VNode} from "virtual-dom";


type ChildRenderer = () => VNode;


export default class Renderer
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _mutators: Mutator[] = [];
    _childRenderers: ChildRenderer[] = [];


    //#region Public Interface

    constructor(settings: DefaultSettings)
    {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>, mutators: Mutator[] = [], childRenderers: ChildRenderer[] = []): void
    {
        this._store = store;
        this._mutators = mutators;
        this._childRenderers = childRenderers;
    }

    getRender()
    {
        return (): VNode =>
        {
            const { Window, DeviceType } = this._settings.stateLocations;
            const { launchPoint, launchPointIcon, launchPointText } = this._settings.classNames;

            let parameters = {
                className: launchPoint,
                onclick: (e: Event): boolean =>
                {
                    this._store?.dispatch(Actions.restoreAlmeWindow(Window.IsMinimized));
                    const input = {
                        eventName: 'LaunchPointClicked',
                        eventValue: "Global",
                        messageType: this._settings.messageConstants.reportingEventRequest,
                    };
                    sendRequest(input);

                    return false;
                },
            } as Dictionary;

            parameters = this._mutators.reduce((currentParams, mutator) => mutator(currentParams), parameters);

            const deviceType = this._store?.getState()[DeviceType];
            const displayedText = (deviceType === this._settings.mobileConstants.deviceTypes.tablet)
                ? this._settings.textConstants.bannerText
                : this._settings.textConstants.launchPointText;

            const textNode = h('div', { className: launchPointText }, displayedText);
            const iconNode = h('div', { className: launchPointIcon }, []);
            const childNodes = this._childRenderers.reduce((currentNodes, render) =>
                [...currentNodes, render()], [textNode, iconNode]);

            return h('button', parameters, childNodes);
        };
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-launch/src/renderers/renderer.ts